import axios from "axios"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { errorMessage } from "../errors"
import { API_URL, serverError } from "../util"

const usePlans = () => {
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [needRefetch, setNeedRefetch] = useState(true)

  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true)

      try {
        const resp = await axios.get(`${API_URL}/plan/list`)
        const { status, message, plans } = resp.data

        setLoading(false)
        if (status === "failed") return setError(errorMessage(message))

        setPlans(plans)
      } catch (error) {
        setLoading(false)
        toast.error(serverError())
      }
    }

    if (needRefetch) {
      fetchPlans()
      setNeedRefetch(false)
    }
  }, [needRefetch])

  const refetch = () => setNeedRefetch(true)

  return { plans, loading, error, refetch }
}

export default usePlans
